import { AfterViewInit, Component,OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsSunburst from 'highcharts/modules/sunburst';



import { Router, ActivatedRoute } from '@angular/router';
declare let $: any;
import * as Aos from 'aos';
import Swal from 'sweetalert2';
import { Buffer } from 'buffer';
// declare let Swiper: any;
// declare let bootstrap: any;
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
//FOR LANGUAGE CONVERSION - STARTS (FOR TOGGLING LANGUAGE CONVERSION)
import { TranslateService } from '@ngx-translate/core';
import { CustomServiceService } from '../../service/custom-service.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsSunburst(Highcharts);

@Component({
  selector: 'app-movement',
  templateUrl: './movement.component.html',
  styleUrls: ['./movement.component.css']
})
export class MovementComponent {

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private route: Router, private encDec: EncryptDecryptService, public translate: TranslateService) {
    //code
    // this.years = this.generateYears(2023, 1970);
    // this.selectedYear = new Date().getFullYear();
    this.generateFinancialYears();
    this.selectedYear = this.getCurrentFinancialYear();
    
};
  stockAmount:any;
  stockAmounts:any;
  DISPAmount:any;
  DISPMAmount:any;
  language:any;

  financialYears: any = [];
  ngOnInit(): void {
    this.selectedYear = this.getCurrentFinancialYear();
    this.start = (this.currentPage - 1) * this.limit;
    this.getQCData('',this.selectedYear, this.start, this.limit, this.currentPage);
    this.getyearlist();
    this.getMoveStateUTList();
    this.language = sessionStorage.getItem('locale'); 

  }

  selectedYear: any ='';
  selectedState: any ='';
  content_apiresponse: any;
  sucess_message: any;
  status: any;
  getQC_Data: any = [];

  start: number = 0;
  limit: number = 10;
  currentPage: number = 1;
  totalRecords: number = 0;
  RefreshBtn: boolean = false;
  btncontent:any = 'Search';

  ShowTabView : boolean =false;
  apirespons:any;
  years: any;
  getMonth_Data: any;
  getDISPMonth_Data: any;


  public getRandomNumber(min: number, max: number, Total: any): any {
    return Total
  }
  public getRandomDecimal(min: number, max: number, total: any): any {
    const randomValue = Math.random() * (max - min) + min;
    const validDecimalPlaces = Math.max(0, Math.min(total, 100));
    return parseFloat((total));
  }

  private getRandomMonth(min: number, max: number, month: any): any {
    const randomValue = Math.random() * (max - min) + min;
    const validDecimalPlaces = Math.max(0, Math.min(month, 100));

    const parsedValue = parseFloat(month);
    return isNaN(parsedValue) ? 0 : parsedValue;
    
  }
  
  generateFinancialYears() {
    const startYear = 2012;
    const endYear = new Date().getFullYear()
    for (let year = startYear; year <= endYear; year++) {
      const start = year;
      const end = year + 1;
      const financialYear = `${start}-${end}`;
      this.financialYears.push(financialYear);
    }
    this.financialYears.sort((k: any, v: any) => v.localeCompare(k)); 
  }

  getCurrentFinancialYear(): string {
    const currentDate = new Date();
    const financialYearStart = new Date(currentDate.getFullYear(), 3, 1); // Assuming a financial year starting on April 1

    if (currentDate < financialYearStart) {
      return `${currentDate.getFullYear() - 1}-${currentDate.getFullYear()}`;
    } else {
      return `${currentDate.getFullYear()}-${currentDate.getFullYear() + 1}`;
    }
  }
  getQCData(selectedState:any,selectedYear:any,start:number,limit:number,currentPage:number){
    let param= {
      'selectedState':selectedState,
      'selectedYear':selectedYear,
      
    }

    this.fciwebservice.getqualitycontrolData(param,'api/viewMovmentDataNew').subscribe((response:any) => {
      this.content_apiresponse = response;
      let respData = this.content_apiresponse.RESPONSE_DATA;
      let respToken = this.content_apiresponse.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response);
        
        this.getQC_Data = response.result;      
        this.getMonth_Data = response.res;
        this.getDISPMonth_Data = response.resDISP;
        this.createChartColumn();
        
        if(response.result.length > 0){
          this.totalRecords = response.result.length;
        
          
        } else {
          this.totalRecords = 0;
        }
      }
      
    });
  }

  public createChartColumn() {
    if(this.selectedState == ''){
    this.stockAmount = this.mapMoveDataToCategories(this.getQC_Data);
    this.DISPAmount = this.mapMoveDataToDISP(this.getQC_Data);
    
    let date = new Date();
    const data: any[] = [];
  
    const categories: string[] = [];
  
  this.StateUTList.forEach((item: { state_english: string; }) => {
    categories.push(item.state_english);
  });
  
  
  
    for (let i = 0; i < categories.length; i++) {
      date.setDate(new Date().getDate() + i);
      data.push({
        name: this.getRandomNumber(0, 10, this.DISPAmount[i]),
        y: this.getRandomNumber(0, 10, this.stockAmount[i]),
        // y:this.stockAmount[i],
        // y: this.getRandomDecimal(1, 10, this.stockAmount[i]),
      });
    }
  
    const chart = Highcharts.chart('chart-movement' as any, {
     
      title: {
        text: this.language === 'English' ? 'Movement' : 'परिचालन'
      },
      chart: {
        type: 'column',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      
      yAxis: {
        min: 0,
        title: undefined,
      },
    
      xAxis: {
        categories: this.StateUTList.map((item: {state_english :any; state_hindi: any;}) => this.language === 'English' ? item.state_english : item.state_hindi),
      },
      tooltip: {
        
        headerFormat: '<div>Grand Total Disp: {point.key}</div>',
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
        // bar: {
        //   dataLabels: {
        //     enabled: true,
        //   },
        // },
      },
      series: [{
        name: 'Grand Total Plan',
        data,
  color: '#006637'
      }],
    } as any);
  
 }
  
  else{
    this.stockAmounts = this.movementMonthData(this.getMonth_Data);
    this.DISPMAmount = this.movementDISPMonthData(this.getDISPMonth_Data);
    let date = new Date();
    const data: any[] = [];

    const categories= ['April','May','June','July','August','Septmeber','October','November','December','January','Febuary','March'];
    for (let i = 0; i < categories.length; i++) {
      date.setDate(new Date().getDate() + i);
      data.push({
        name: this.getRandomMonth(1, 10, this.DISPMAmount[i]),
        y: this.getRandomMonth(1, 10, this.stockAmounts[i]),
      });
    }
    const chart = Highcharts.chart('chart-movement' as any, {
      title: {
        text: 'Movement'
      },
      chart: {
        type: 'column',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      
      yAxis: {
        min: 0,
        title: undefined,
      },
      xAxis: {
        categories: ['April','May','June','July','August','Septmeber','October','November','December','January','Febuary','March'],
      },
      tooltip: {
        headerFormat: `<div>DISP: {point.key}</div>`,
        pointFormat: `<div>{series.name}: {point.y}</div>`,
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
        // bar: {
        //   dataLabels: {
        //     enabled: true,
        //   },
        // },
      },
      series: [{
        name: 'Plan',
        data,
 color: '#006637'
      }],
    } as any);
  }
}

 

  statelist: any = [];
  yearlist: any = [];
  getyearlist() {
    let param = {
      test: '',
    };
    this.httpservice
      .getqualitycontrolData(param, `api/getMovmentDataParamData`)
      .subscribe((response: any) => {
        this.content_apiresponse = response;
        let respData = this.content_apiresponse.RESPONSE_DATA;
        let respToken = this.content_apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          // console.log(response);
          if (response.status == 1) {
            this.yearlist = response.yearlist;
            this.statelist = response.statelist;
          } else {
            Swal.fire({
              icon: 'error',
              text: response.messsage,
            });
          }
        }
      }); 
  }

  pageChanged(page: any) {
  let param_arr = []; 
  let category,fyear;
  category="";
  fyear="";
  this.totalRecords = 0;
  this.getQC_Data = [];
  this.currentPage=page;
  this.start=(this.currentPage - 1)*this.limit;
  this.getQCData(this.selectedState,this.selectedYear,this.start,this.limit,this.currentPage);
  }
 


  Toggle(boolean: boolean){
    this.ShowTabView = boolean;
    $('.Toggle').removeClass('active');
    if(boolean){
      $('#movmchart').addClass('active');
    } else {
      $('#movmtbl').addClass('active');
    }

    this.createChartColumn();
  }


  public ngAfterViewInit(): void {
    // this.createChartColumn();
    // this.getMoveStateUTList();
  }

  private generateYears(startYear: number, endYear: number): number[] {
    const years: number[] = [];
    for (let year = startYear; year >= endYear; year--) {
      years.push(year);
    }
    return years;
  }

  onStateSelected(): void {
    this.getQCData(this.selectedState,this.selectedYear,this.start,this.limit,this.currentPage);
  }


  onYearSelected(): void {

    this.getQCData(this.selectedState,this.selectedYear,this.start,this.limit,this.currentPage);
  }
  

  StateUTList:any=[];

public getMoveStateUTList(){
  let param ={

  }
  this.fciwebservice.getMoveStateUTList(param).subscribe((response:any) => {

     switch (response.type) { 
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.apirespons = response.body;
        let respData = this.apirespons.RESPONSE_DATA;
        let respToken = this.apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let res = JSON.parse(Buffer.from(respData, 'base64').toString());
           this.StateUTList = res.result;   
             
        } 
    }
  });

}
public mapMoveDataToCategories(stockData: any[]): number[] {
  
  const categories: string[] = [];
  this.StateUTList.forEach((item: { state_english: string; }) => {
    categories.push(item.state_english);
  });
  const amounts: number[] = [];

  
  for (const category of categories) {
    const stateData = stockData.find(item => item.state_english == category);
    if (stateData) {
      // amounts.push(stateData.grand_total_plan);
      const grandTotalPlan = parseFloat(stateData.grand_total_plan);
      amounts.push(isNaN(grandTotalPlan) ? 0 : grandTotalPlan);
    } else {
      amounts.push(0);
    }
  }  
  return amounts;
}


public movementMonthData(stockData: any[]): any[] {
  const months = ['vch_april', 'vch_may', 'vch_june', 'vch_july', 'vch_august', 'vch_september', 'vch_october', 'vch_november', 'vch_december', 'vch_january', 'vch_february', 'vch_march'];
  const amounts: number[] = new Array(months.length).fill(0);


  if (Array.isArray(stockData)) {
    stockData.forEach((item) => {
      for (let i = 0; i < months.length; i++) {
        amounts[i] += parseFloat(item[months[i]]);
      }
    });
  } else {
   // console.error('stockData is not an array:', stockData);
  }
  // console.log(amounts);
  return amounts;
}

public movementDISPMonthData(stockData: any[]): any[] {
  const months = ['vch_april_disp', 'vch_may_disp', 'vch_june_disp', 'vch_july_disp', 'vch_august_disp', 'vch_september_disp', 'vch_october_disp', 'vch_november_disp', 'vch_december_disp', 'vch_january_disp', 'vch_february_disp', 'vch_march_disp'];
  const amounts: number[] = new Array(months.length).fill(0);


  if (Array.isArray(stockData)) {
    stockData.forEach((item) => {
      for (let i = 0; i < months.length; i++) {
        amounts[i] += parseFloat(item[months[i]]);
      }
    });
  } else {
   // console.error('stockData is not an array:', stockData);
  }
  
  return amounts;
}


public mapMoveDataToDISP(stockData: any[]): number[] {
  const categories: string[] = [];
  this.StateUTList.forEach((item: { state_english: string; }) => {
    categories.push(item.state_english);
  });
  const amounts: number[] = [];

  for (const category of categories) {
    const stateData = stockData.find(item => item.state_english == category);
    if (stateData) {
      // amounts.push(stateData.grand_total_plan);
      const grandTotalDisp = parseFloat(stateData.grand_total_disp);
      amounts.push(isNaN(grandTotalDisp) ? 0 : grandTotalDisp);
    } else {
      amounts.push(0);
    }
  }  
  return amounts;
}
  public  mapMoveMonthData(stockData: any[]): any[] {
    // console.log(stockData);
      // const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
      const months = [ 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december','january', 'february', 'march'];
      const amounts: number[] = new Array(months.length).fill(0);
      // console.log(stockData);
      stockData.forEach((item) => {
        for (let i = 0; i < months.length; i++) {
          amounts[i] += parseFloat(item[months[i]]);
          // amounts.push(parseFloat(months[i]));
        }
      });
      return amounts;
    }
    

  }

